import { useState, useEffect, useContext } from "react";
import { toast } from "react-toastify";
import { Authorization } from "../../Context/Authorization";
import Preloader from "../../shared/PreLoaders";
import { AuthContext } from "../../Context/AuthContext";
import JfmcTypes from "./Components/JfmcTypes";

const ManageJfmcTypes = () => {
  const [jfmcTypes, setJfmcTypes]       = useState([]);
  const [loading, setLoading]           = useState(false);
  const [showAddPopup, setShowAddPopup] = useState(false);
  const { permissions }                 = useContext(AuthContext);
  const Api                             = process.env.REACT_APP_API;

  useEffect(() => { fetchJfmcTypes(); }, []);

  const fetchJfmcTypes = async () => {
    setLoading(true);
    try {
      const config = Authorization();
      const response = await fetch(`${Api}/api/jfmc-Types`, { headers: { ...config.headers } });
      const data = await response.json();
      setJfmcTypes(data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleAddSuccess = (newType) => {
    setJfmcTypes((prev) => [...prev, newType]);
    setShowAddPopup(false);
  };

  const handleDeleteJfmcType = async (id) => {
    if (!window.confirm("Are you sure you want to delete this JFMC Type?")) return;
    try {
      const config = Authorization();
      const response = await fetch(`${Api}/api/jfmc-Types/${id}`, {
        method: "DELETE",
        headers: { "Content-Type": "application/json", ...config.headers },
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.message);
      setJfmcTypes((prev) => prev.filter((t) => t._id !== id));
      toast.success("JFMC Type deleted successfully");
    } catch (err) {
      toast.error(err.message || "Delete failed");
    }
  };

  /* ════════════════════════════════════════════
     RENDER
  ════════════════════════════════════════════ */
  return (
    <div>
      {loading && <Preloader loading={loading} />}

      {/* ── Page Header ── */}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 20 }}>
        <div>
          <h4 style={{ margin: 0, fontWeight: 700, color: "#1A202C", fontSize: 18 }}>JFMC Types</h4>
          <div style={{ fontSize: 12, color: "#718096", marginTop: 3 }}>
            <span style={{ color: "#A0AEC0" }}>JFMC</span>
            <span style={{ margin: "0 6px", color: "#CBD5E0" }}>›</span>
            <span style={{ color: "#2E7D32", fontWeight: 600 }}>JFMC Types</span>
          </div>
        </div>
        {permissions.includes("AddState") && (
          <button
            onClick={() => setShowAddPopup(true)}
            style={{ padding: "9px 20px", background: "linear-gradient(135deg,#1B5E20,#2E7D32)", color: "#fff", border: "none", borderRadius: 8, fontSize: 13, fontWeight: 700, cursor: "pointer", display: "flex", alignItems: "center", gap: 7, boxShadow: "0 2px 8px rgba(46,125,50,0.3)" }}
          >
            <i className="mdi mdi-plus" style={{ fontSize: 16 }} />
            Add JFMC Type
          </button>
        )}
      </div>

      {/* ── Table Card ── */}
      <div style={{ background: "#fff", borderRadius: 12, border: "1px solid #E2E8F0", boxShadow: "0 1px 4px rgba(0,0,0,0.07)", overflow: "hidden" }}>

        {/* Card header */}
        <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "12px 16px", borderBottom: "1px solid #EDF2F7", background: "linear-gradient(135deg,#1B5E20,#2E7D32)" }}>
          <span style={{ width: 30, height: 30, background: "rgba(255,255,255,0.15)", borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontSize: 15 }}>
            <i className="mdi mdi-tag-multiple-outline" />
          </span>
          <span style={{ fontSize: 13, fontWeight: 700, color: "#fff" }}>All JFMC Types</span>
          <span style={{ marginLeft: "auto", background: "rgba(255,255,255,0.2)", color: "#fff", fontSize: 11, fontWeight: 700, padding: "2px 10px", borderRadius: 50 }}>
            {jfmcTypes.length} records
          </span>
        </div>

        {/* Table */}
        <div style={{ padding: "0 4px" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
            <thead>
              <tr>
                {["#", "JFMC Type Name", "JFMC Code", "Description", "Actions"].map((h) => (
                  <th key={h} style={{ padding: "11px 16px", textAlign: "left", fontWeight: 600, fontSize: 12, color: "#4A5568", borderBottom: "1px solid #EDF2F7", background: "#F7FAFC" }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {jfmcTypes.length === 0 && !loading ? (
                <tr>
                  <td colSpan={5} style={{ padding: "48px 24px", textAlign: "center" }}>
                    <div style={{ width: 52, height: 52, background: "#E8F5E9", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 12px" }}>
                      <i className="mdi mdi-tag-outline" style={{ fontSize: 24, color: "#2E7D32" }} />
                    </div>
                    <div style={{ fontSize: 14, fontWeight: 600, color: "#2D3748" }}>No JFMC Types found</div>
                    <div style={{ fontSize: 12, color: "#A0AEC0", marginTop: 4 }}>Click "Add JFMC Type" to create one</div>
                  </td>
                </tr>
              ) : (
                jfmcTypes.map((item, index) => (
                  <tr key={item._id} style={{ borderBottom: "1px solid #EDF2F7", transition: "background 0.15s" }}
                    onMouseEnter={(e) => e.currentTarget.style.background = "#F7FAFC"}
                    onMouseLeave={(e) => e.currentTarget.style.background = "transparent"}
                  >
                    <td style={{ padding: "12px 16px", color: "#718096", fontWeight: 600 }}>{index + 1}</td>
                    <td style={{ padding: "12px 16px", color: "#1A202C", fontWeight: 600 }}>{item.jfmcTypeName}</td>
                    <td style={{ padding: "12px 16px" }}>
                      <span style={{ background: "#E8F5E9", color: "#2E7D32", fontSize: 12, fontWeight: 700, padding: "3px 10px", borderRadius: 50 }}>{item.jfmcTypeCode}</span>
                    </td>
                    <td style={{ padding: "12px 16px", color: "#4A5568" }}>{item.description}</td>
                    <td style={{ padding: "12px 16px" }}>
                      {permissions.includes("DeleteState") && (
                        <i
                          className="mdi mdi-delete"
                          title="Delete"
                          style={{ fontSize: "1.2rem", cursor: "pointer", color: "#C62828" }}
                          onClick={() => handleDeleteJfmcType(item._id)}
                        />
                      )}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {showAddPopup && (
        <JfmcTypes onClose={() => setShowAddPopup(false)} onAddJfmcType={handleAddSuccess} />
      )}
    </div>
  );
};

export default ManageJfmcTypes;
